module.exports = [
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/eugenio_pace-1bfa3230d1.jpg",
		"name": "Eugenio Pace",
		"title": "Co-Founder, CEO"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/matias_woloski-2479357374.jpg",
		"name": "Matías Woloski",
		"title": "Co-Founder, CTO"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/lewis_carpenter-4ba0360d71.jpg",
		"name": "Lewis Carpenter",
		"title": "CMO"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/chris_dukelow-f1766a8cbd.jpg",
		"name": "Chris Dukelow",
		"title": "CFO"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/gonto-b80ba1869e.jpg",
		"name": "Martín Gontovnikas",
		"title": "VP, Marketing"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/dave_wilner-29a808f78e.jpg",
		"name": "Dave Wilner",
		"title": "VP, Sales"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/tomasz_janczuk-503759e8a6.jpg",
		"name": "Tomasz Janczuk",
		"title": "Chief Webtask Architect"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/mark_olson-643f46097f.jpg",
		"name": "Mark Olson",
		"title": "VP, Finance & Operations"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/joan_pepin-f9364a6889.jpg",
		"name": "Joan Pepin",
		"title": "Chief Information Security Officer"
	},
	{
		"avatarUrl": "https://cdn.auth0.com/website/assets/pages/about/img/leadership/jeremy_freeland-847d5903a0.jpg",
		"name": "Jeremy Freeland",
		"title": "General Counsel"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/data/leadership.json
// module id = 1353
// module chunks = 0